export { default as Tab } from './Tab';
export { default as Tabs } from './Tabs';
export { default as TabsContent } from './TabsContent';
